import MuiPagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { useSearchParams } from '@remix-run/react';
import { RemixLink } from '~/components/shared/links';
import { getPageParamValue, PAGE_PARAM } from '~/utils/searchParams';

function getPageCount(count: number, perPage: number) {
  return Math.ceil(count / perPage);
}

function getPage(pageCount: number, pageParamValue: number) {
  return Math.min(pageCount, Math.max(1, pageParamValue));
}

function getPageLink(page: number | null, searchParams: URLSearchParams) {
  const pageSearchParams = new URLSearchParams(searchParams);

  if (page === null || page === 1) {
    pageSearchParams.delete(PAGE_PARAM);
  } else {
    pageSearchParams.set(PAGE_PARAM, page.toString());
  }

  return '?' + pageSearchParams;
}

type PaginationProps = {
  count: number;
  itemsPerPage: number;
};

export default function Pagination({ count, itemsPerPage }: PaginationProps) {
  const [searchParams] = useSearchParams();

  const pageCount = getPageCount(count, itemsPerPage);
  const page = getPage(pageCount, getPageParamValue(searchParams));

  return (
    <MuiPagination
      page={page}
      count={pageCount}
      shape="rounded"
      size="large"
      color="primary"
      renderItem={(item) => (
        <PaginationItem component={RemixLink} href={getPageLink(item.page, searchParams)} {...item} />
      )}
    />
  );
}
